<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>
 
    </nav> -->
    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel" >
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 style="color: black !important;" class="page-title text-primary">NDA</h2>
                </div>
                <div class="form" [hidden]="isShownWrite">
                    <div class="row" style="padding-bottom:2rem;">

                        <!-- <div class="col-lg-4">
                            <label>Name</label><span style="color: red;">*</span><br />
                            <input type="text" id="ContractName" [(ngModel)]="NDAName" class="txt-input" />
                        </div> -->
                        <div class="col-md-2" style="text-align: left;">
                            <label>Customer Code </label><span style="color: red;">*</span><br />
                            <select class="txt-input" [(ngModel)]="onboardingid" disabled 
                                style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ;">
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let obd of onboard" value={{obd.onboardingid}}>{{obd.customcode}}
                                </option>
                            </select>
                        </div>

                        <div class="col-lg-3">
                            <label>Contract</label><span style="color: red;">*</span><br />
                            <select class="txt-input" [(ngModel)]="contractsid" (change)="Show($event)"
                                style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ;">
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let cnts of Contracts" value={{cnts.contractsid}}>
                                    {{cnts.contractNumber}}</option>
                            </select>
                        </div>
                        <div class="col-lg-4" [hidden]="isShownservice">
                            <label>Services</label><br />
                            <input type="text" [(ngModel)]="cntService" readonly class="txt-input">
                        </div>
                    </div>

                    <div class="row" style="padding-bottom:2rem;">
                        <div class="col-md-3" style="max-width: 20% !important;">
                            <label>Valid From</label><span style="color: red;">*</span><br />
                            <input type="date" id="Validfrom" [(ngModel)]="Validfrom" placeholder="" class="txt-input">
                        </div>
                        <div class="col-md-3" style="max-width: 20% !important;">
                            <label>Valid To</label><span style="color: red;">*</span><br />
                            <input type="date" id="ValidTo" [(ngModel)]="ValidTo" placeholder="" class="txt-input">
                        </div>
                    </div>

                    <div class="row" style="padding-bottom:2rem;">
                        <div class="col-lg-9">
                            <div class="row" style="padding-bottom:2rem;" *ngFor="let ad of Addcomp">
                                <div class="col-lg-4">
                                    <label>Signed by(Company)</label><span style="color: red;">*</span><br />
                                    <input type="text" id="{{ad.CompanyName}}" 
                                        class="txt-input" />
                                </div>
                                <div class="col-lg-3" style="max-width: 25% !important;">
                                    <label>Signed Role</label><span style="color: red;">*</span><br />
                                    <input type="text" id="{{ad.CompanyRole}}" class="txt-input"/>
                                </div>
                                <div class="col-lg-3" style="max-width: 25% !important;">
                                    <label>Signed Date</label><span style="color: red;">*</span><br />
                                    <input type="date" id="{{ad.CompanyDate}}" class="txt-input"/>
                                    <span id={{ad.companyvar}} style="visibility: hidden;">{{ad.CompanyId}}</span>
                                </div>
                                <div class="col-lg-2" style="max-width: 25% !important;padding-top: 35px;">
                                    <img src="../../assets/Delete_Icon.png"  (click)="RemoveCompany(ad)" />
                                    <!-- <button class="bttn-save " (click)="RemoveCompany(ad)">Del<img src="../../assets/WhitePlus.png"
                                        style="padding-top:0px">
                                </button> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2" style="padding-top: 25px;">
                            <button class="bttn-save " (click)="AddCompany()">Add<img src="../../assets/WhitePlus.png"
                                    style="padding-top: 0px;">
                            </button>
                        </div>
                    </div>

                    <div class="row" style="padding-bottom:2rem;">
                        <div class="col-lg-9">
                            <div class="row" *ngFor="let ac of Adclient" style="padding-bottom:2rem;">
                                <div class="col-lg-4">
                                    <label>Signed by(Client)</label><span style="color: red;">*</span><br />
                                    <input type="text" id="{{ac.ClientName}}" class="txt-input" />
                                </div>
                                <div class="col-lg-3" style="max-width: 25% !important;">
                                    <label>Signed Role</label><span style="color: red;">*</span><br />
                                    <input type="text" id="{{ac.ClientRole}}"  class="txt-input" />
                                </div>
                                <div class="col-lg-3" style="max-width: 25% !important;">
                                    <label>Signed Date</label><span style="color: red;">*</span><br />
                                    <input type="date" id="{{ac.ClientDate}}" class="txt-input" />
                                    <span id={{ac.clientvar}} style="visibility: hidden;">{{ac.ClientId}}</span>
                                </div>
                                <div class="col-lg-2" style="max-width: 25% !important;padding-top: 35px;">
                                    <img src="../../assets/Delete_Icon.png"  (click)="RemoveClient(ac)" />
                                    <!-- <button class="bttn-save " (click)="RemoveClient(ac)">Del<img src="../../assets/WhitePlus.png"
                                        style="padding-top:0px">
                                </button> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2" style="padding-top: 25px;">
                            <button class="bttn-save " (click)="AddClient()">Add<img src="../../assets/WhitePlus.png"
                                    style="padding-top: 0px;"></button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 grid-margin">
                            <label>Document Upload</label><br />
                            <div class="col-lg-6" style="border: ridge;padding-bottom: 2em;">
                                <div class="clearfix">
                                    <div class="upload-btn-wrapper" style="padding-left: 50px;">
                                        <button class="btnUpload">Upload&nbsp; <img src="../../assets/UploadIcon.png">
                                        </button>
                                        <input type="file" #file (change)="uploadFile(file.files)" id="myfile"
                                            multiple />
                                    </div>
                                </div>
                                <div [hidden]="isShowndoclist">
                                    <!-- <span><a href="{{imageurl}}" target="_blank"><label for="select" [(ngModel)]="select" id="select" style="padding-top:35px;font-size: 12px;"></label></a></span> -->
                                    <ol type="1" class="selects">
                                        <li *ngFor="let slt of selects;let index=index">
                                            <span><a href="{{slt.fileURL}}" target="_blank">{{slt.filename}}</a>
                                                <img src="../../assets/Delete_Icon.png"  (click)="RemoveDocument(slt,index)" />
                                            </span>
                                        </li>
                                    </ol>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-5" style="padding-top:1em;">
                            <label>Description</label> <br />
                            <textarea cols="40" rows="3" id="description" [(ngModel)]="description"
                                class="txt-input"></textarea>
                        </div>
                        <div class="col-lg-2" style="padding-top: 75px;" [hidden]="isShownActive">
                            <input type="checkbox"> Set As Inactive
                        </div>
                        <div class="col-lg-4" style="padding-top: 4rem;">
                            <button class="bttn-save " (click)="Submitnda()" [hidden]="isShownSaveBtn">SAVE</button>
                            &nbsp;&nbsp;
                            <button class="bttn-Update" (click)="Updatenda()"
                                [hidden]="isShownUpdateBtn">Update</button>&nbsp;&nbsp;
                            <button class="bttn-clear" (click)="Clearnda()">Clear</button>
                        </div>
                    </div>
                    <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                        <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                    </div>


                </div>
            </div>

            <div class="content-wrapper">
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body" style="width:fit-content;">
                                <div class="row">
                                    <div class="col-12 grid-margin">
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-3"></div>
                                                    <div class="col-lg-9">
                                                        <div class="form-group">
                                                            <div class="input-group">
                                                                <!-- <label style="padding-right: 25px;">Search</label> -->
                                                                <input type="text" placeholder="Search"
                                                                    [(ngModel)]="searchText"
                                                                    (keyup)="applyFilter($event.target.value)"
                                                                    class="txt-Search"> <i class="fa fa-search fa-2x"
                                                                    style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                                <!-- <input type="text" class="form-control"
                                                                    placeholder="Search..." aria-label="Search..."
                                                                    aria-describedby="basic-addon2">
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-sm btn-gradient-danger"
                                                                        type="button">Search</button>
                                                                </div> -->
                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color: black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="name">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Customer Code</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditNDA(element)" style="cursor: pointer;">
                                                                {{element.name}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="services">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Services</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditNDA(element)" style="cursor: pointer;">
                                                                {{element.services}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="validfrom">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Valid From</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditNDA(element)" style="cursor: pointer;">
                                                                {{element.validfrom}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="validto">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Valid To</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditNDA(element)" style="cursor: pointer;">
                                                                {{element.validto}}
                                                            </td>
                                                        </ng-container>

                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditNDA(element)" style="cursor: pointer;">
                                                                {{element.status}}
                                                            </td>
                                                        </ng-container>
                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">
                                        <!-- <p class="text-primary" style="float:right"><i>
                                                &nbsp;</i>Page 1,2,3,4<i>&nbsp;></i></p> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->
        </div>
    </div>
</div>